module.exports = __webpack_public_path__ + "img/section1.2f1267fa.png";